import { pick } from 'lodash'

const transformToSaveUserArgs = data => ({
  ...pick(data, [
    'name',
    'email',
    'isActive',
    'roleIds',
    'cuisineTypeIds',
    'languageIds',
  ]),
  roleIds: data.roleIds,
})

export default transformToSaveUserArgs
